import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, ExternalLink, Loader2 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { http, TOKEN_KEY } from "@/lib/api";
import { AdminOrders } from "@/components/admin/AdminOrders";
import { AdminMenu } from "@/components/admin/AdminMenu";
import { AdminSettings } from "@/components/admin/AdminSettings";
import { AdminSecurity } from "@/components/admin/AdminSecurity";

const TABS = [["orders", "Pedidos"], ["menu", "Menú y stock"], ["settings", "Local"], ["security", "PIN"]];

export default function AdminPage() {
  const navigate = useNavigate();
  const [ok, setOk] = useState(false);

  useEffect(() => {
    http.get("/admin/me").then(() => setOk(true)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      navigate("/", { replace: true });
    });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    navigate("/");
  };

  if (!ok) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-amber-400" /></div>;

  return (
    <div className="min-h-screen" data-testid="admin-page">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-[#120E0E]/85 border-b border-[#2E2323]">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center gap-3">
          <h1 className="text-xl font-extrabold">Panel <span className="text-amber-400">Admin</span></h1>
          <Link to="/" className="ml-auto inline-flex items-center gap-1 text-xs text-[#A89F91] hover:text-amber-100" data-testid="admin-view-menu-link"><ExternalLink className="w-3.5 h-3.5" /> Ver menú</Link>
          <button onClick={logout} className="inline-flex items-center gap-1 text-xs text-[#A89F91] hover:text-red-400" data-testid="admin-logout-btn"><LogOut className="w-3.5 h-3.5" /> Salir</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-5">
        <Tabs defaultValue="orders">
          <TabsList className="w-full grid grid-cols-4 bg-[#1C1515] border border-[#2E2323] h-11">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="text-xs sm:text-sm data-[state=active]:bg-[#DC2626] data-[state=active]:text-white">{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="orders" className="mt-5"><AdminOrders /></TabsContent>
          <TabsContent value="menu" className="mt-5"><AdminMenu /></TabsContent>
          <TabsContent value="settings" className="mt-5"><AdminSettings /></TabsContent>
          <TabsContent value="security" className="mt-5"><AdminSecurity /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
